<div fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row">
    Dodaj użytkownika
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex="100">

      <app-dict-users fxFlex="100" label="Użytkownik" [control]="accountUserControl" [multiple]="false"></app-dict-users>

    </div>

  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton"
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

